import React from "react"

export const CallOutlineSvg
 = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">

        <path d="M21.1409 17.5307C20.3965 16.7807 18.5937 15.6862 17.719 15.2451C16.58 14.6713 16.4862 14.6245 15.5909 15.2896C14.9937 15.7335 14.5967 16.1301 13.8978 15.981C13.1989 15.832 11.6801 14.9915 10.3503 13.6659C9.02042 12.3402 8.13121 10.7774 7.98167 10.0809C7.83214 9.3843 8.23527 8.99195 8.67496 8.39336C9.29464 7.54961 9.24777 7.40898 8.71808 6.26992C8.30511 5.38398 7.17871 3.59805 6.42589 2.85742C5.62058 2.06195 5.62058 2.20258 5.10167 2.4182C4.67922 2.59595 4.27394 2.812 3.89089 3.06367C3.14089 3.56195 2.72464 3.97586 2.43355 4.59789C2.14246 5.21992 2.01167 6.6782 3.51496 9.40914C5.01824 12.1401 6.07292 13.5365 8.25589 15.7134C10.4389 17.8902 12.1175 19.0607 14.5714 20.437C17.607 22.1371 18.7714 21.8057 19.3953 21.5151C20.0192 21.2245 20.435 20.812 20.9342 20.062C21.1865 19.6796 21.403 19.2747 21.5811 18.8526C21.7971 18.3355 21.9378 18.3355 21.1409 17.5307Z" stroke="black" stroke-width="1.125" stroke-miterlimit="10"/>
        
        </svg>
        
        
    )
}